module.exports = "/images/lakeshore@3x.png?6fd2ec2f299943daee1f326b1b015a8d";